<template>
  <v-dialog :value="value" @input="(v) => $emit('input', v)" width="400" persistent>
    <v-card>
      <v-card-title> Client Payment </v-card-title>
      <v-card-text class="black--text">
        <v-row v-if="isPaid == true || remainingTotal === 0" class="green pa-1 mb-1" justify="center">
          <span class="subtitle-2">PAID</span>
        </v-row>

        <v-row justify="center">
          <v-btn-toggle v-model="paymentType" mandatory>
            <v-btn value="FULL" small> Full </v-btn>
            <v-btn value="PARTIAL" small> Partial </v-btn>
            <v-btn value="DEPOSIT" small> Deposit </v-btn>
          </v-btn-toggle>
        </v-row>

        <TotalPaidUnpaidRow :totalInvoice="totalInvoice" :remainingTotal="remainingTotal" :paidAmount="paidAmount" />

        <v-divider />

        <Payment
          v-if="paymentType === 'PARTIAL'"
          v-model="invoiceValue"
          :totalInvoice="totalInvoice"
          :remainingTotal="remainingTotal"
          :paidAmount="paidAmount"
        />

        <Payment
          v-if="paymentType === 'FULL'"
          v-model="fullInvoice"
          altlabel="Amount Paid"
          :totalInvoice="totalInvoice"
          :remainingTotal="remainingTotal"
          :paidAmount="paidAmount"
        />

        <Deposit v-if="paymentType === 'DEPOSIT'" v-model="invoiceValue" :defaultValue="defaultDeposit" />

        <PaymentDateRow v-model="invoiceDate" />
        <PaidStatusRow v-model="isPaid" :disabled="remainingTotal === 0" />
      </v-card-text>

      <v-card-actions>
        <g-button @onclick="clear" label="Cancel" />
        <div class="flex-grow-1"></div>
        <g-button type="primary" :loading="loading" @onclick="update" label="Update" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import money from "@/services/money";
import format from "@/services/format";

import Deposit from "@/modules/finances.report/components/paymentTypes/Deposit";
import Payment from "@/modules/finances.report/components/paymentTypes/Payment";
import TotalPaidUnpaidRow from "@/modules/finances.report/components/paymentTypes/_TotalPaidUnpaidRow";
import PaymentDateRow from "@/modules/finances.report/components/paymentTypes/_PaymentDateRow";
import PaidStatusRow from "@/modules/finances.report/components/paymentTypes/_PaidStatusRow";

export default {
  props: {
    bookingId: String,
    value: Boolean,
    totalInvoice: [Number, String],
  },
  components: {
    Deposit,
    Payment,
    TotalPaidUnpaidRow,
    PaymentDateRow,
    PaidStatusRow,
  },
  data() {
    return {
      paymentType: "FULL",
      invoiceDate: format.convertDate(new Date()),
      invoiceValue: null,
      fullInvoice: 0,
      loading: false,
      isPaid: false,
    };
  },
  watch: {
    value(open) {
      if (open) {
        this.resetForm();
      }
    },
  },
  computed: {
    paidAmount() {
      return this.$store.getters["FinanceReportStore/partPaidInvoice"];
    },

    defaultDeposit() {
      const invoice = this.$store.getters["FinanceReportStore/client_invoice"];

      return invoice.total_invoice;
    },

    remainingTotal() {
      const total = money._num(this.totalInvoice);
      const paid = money._num(this.paidAmount);
      return total ? Math.max(total - paid, 0) : 0;
    },

    isCustomerPaymentPaid() {
      return this.$store.getters["FinanceReportStore/customerPaymentPaid"];
    },

    paymentAmount() {
      if (this.paymentType === "FULL") return money._num(this.fullInvoice);
      return money._num(this.invoiceValue);
    },
  },
  methods: {
    resetForm() {
      this.paymentType = "FULL";
      this.invoiceDate = format.convertDate(new Date());
      this.invoiceValue = null;
      this.isPaid = this.isCustomerPaymentPaid;
      this.fullInvoice = this.remainingTotal;
    },
    update() {
      if (!this.paymentAmount) {
        this.$root.$error("Please enter a payment amount");
        return;
      }

      this.loading = true;
      this.addClientPayment();
    },
    addClientPayment() {
      this.$store
        .dispatch("FinanceReportStore/addClientPayment", {
          booking_id: this.bookingId,
          data: {
            paid_amount: this.paymentAmount,
            paid_date: this.invoiceDate,
            isdeposit: this.paymentType === "DEPOSIT" ? 1 : 0,
          },
        })
        .then((payment) => this.updateBookingData(payment))
        .then(() => this.$store.dispatch("FinanceReportStore/syncReport", this.bookingId))
        .then(() => {
          this.clear();
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          this.$root.$error(err?.data || err?.message || err || "Failed to save payment");
        });
    },
    updateBookingData(payment) {
      const bookingData = this.$store.getters["FinanceReportStore/bookingData"];

      return this.$store.dispatch("FinanceReportStore/updateBookingData", {
        booking_id: this.bookingId,
        patch: {
          customer_payment_paid: this.isPaid,
          client_payment_types: {
            ...(bookingData.client_payment_types || {}),
            [payment.id]: this.paymentType,
          },
        },
      });
    },
    clear() {
      this.resetForm();
      this.$emit("input", false);
    },
  },
};
</script>
